import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const UTILITIES = {
  ROOT: `${PRIVATE_ROOT}/apartment/utilities`,
  INVOICES: `${PRIVATE_ROOT}/apartment/utilities/invoices`,
}

export const VIEW_UTILITY = `${PRIVATE_ROOT}/apartment/utility/:id`
